export const translations = {
	'Properties': {
		no: 'Egenskaper',
	},
	'Properties {0}': {
		no: 'Egenskaper {0}',
	},
	'Service root node': {
		no: 'Tjeneste rot node',
	},
	'Linked': {
		no: 'Link',
	},
	'Ceeview standard shape': {
		no: 'Ceeview standard form',
	},
	'Time format': {
		no: 'Tidsformat',
	},
	'Dashboard was last updated: ': {
		no: 'Dashboard var sist oppdatert: ',
	},
	'Revert windows position': {
		no: 'Tilbakestill vinduposisjon',
	},
	'Icon color': {
		no: 'ikonfarge',
	},
	'Background image': {
		no: 'Bakgrunnsbilde',
	},
	'Clear image': {
		no: 'Slett bilde',
	},
};
